// Video Slider with Swiper and Auto Play/Pause
(function () {
    // Wait for Swiper to be available
    function initVideoSwiper() {
        if (typeof Swiper === 'undefined') {
            setTimeout(initVideoSwiper, 100);
            return;
        }

        const videoSwiperEl = document.querySelector('.kroslo-metal-meets__swiper');
        if (!videoSwiperEl) return;

        // Global mute state - all videos share the same state
        let isGlobalMuted = true;

        // Get all videos and buttons
        const allVideos = videoSwiperEl.querySelectorAll('.kroslo-metal-meets__video');
        const allMuteButtons = videoSwiperEl.querySelectorAll('.kroslo-metal-meets__mute-btn');

        // Function to update all videos and buttons to the global mute state
        function updateGlobalMuteState() {
            allVideos.forEach((video, index) => {
                if (isGlobalMuted) {
                    video.muted = true;
                    video.volume = 0;
                    video.setAttribute('muted', '');
                } else {
                    video.muted = false;
                    video.volume = 1;
                    video.removeAttribute('muted');
                }

                // Update corresponding button
                if (allMuteButtons[index]) {
                    if (isGlobalMuted) {
                        allMuteButtons[index].classList.remove('unmuted');
                    } else {
                        allMuteButtons[index].classList.add('unmuted');
                    }
                }
            });
        }

        // Initialize all videos as muted
        allVideos.forEach((video) => {
            video.muted = true;
            video.volume = 0;
            video.setAttribute('muted', '');
        });

        // Add global mute/unmute toggle functionality to all buttons
        allMuteButtons.forEach((button) => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Toggle global mute state
                isGlobalMuted = !isGlobalMuted;
                
                // Update all videos and buttons
                updateGlobalMuteState();
            });
        });

        // Initialize Swiper
        const videoSwiper = new Swiper('.kroslo-metal-meets__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: false,
        speed: 700,
        watchOverflow: true,
        navigation: {
            nextEl: '.kroslo-metal-meets__next-btn',
            prevEl: '.kroslo-metal-meets__prev-btn',
        },
        on: {
            init: function() {
                // Apply global mute state to all videos
                updateGlobalMuteState();
                
                // Ensure all videos are set up correctly before playing
                this.slides.forEach((slide, index) => {
                    const video = slide.querySelector('.kroslo-metal-meets__video');
                    
                    if (video) {
                        if (index === this.activeIndex) {
                            // Play first video on init
                            video.play().catch(err => console.log('Video autoplay prevented:', err));
                        } else {
                            // Pause all other videos
                            video.pause();
                            video.currentTime = 0;
                        }
                    }
                });
            },
            slideChange: function() {
                // Pause all videos
                this.slides.forEach(slide => {
                    const video = slide.querySelector('.kroslo-metal-meets__video');
                    if (video) {
                        video.pause();
                    }
                });
                
                // Play active video (with global mute state applied)
                const activeSlide = this.slides[this.activeIndex];
                const activeVideo = activeSlide ? activeSlide.querySelector('.kroslo-metal-meets__video') : null;
                if (activeVideo) {
                    // Apply global mute state before playing
                    if (isGlobalMuted) {
                        activeVideo.muted = true;
                        activeVideo.volume = 0;
                    } else {
                        activeVideo.muted = false;
                        activeVideo.volume = 1;
                    }
                    activeVideo.play().catch(err => console.log('Video play error:', err));
                }
            }
        }
        });

        // Handle window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                videoSwiper.update();
            }, 250);
        });

        // Handle video end (ensure looping, use global mute state)
        const videos = videoSwiperEl.querySelectorAll('.kroslo-metal-meets__video');
        videos.forEach((video) => {
            // Apply global mute state when video metadata loads
            video.addEventListener('loadedmetadata', function() {
                if (isGlobalMuted) {
                    this.muted = true;
                    this.volume = 0;
                    this.setAttribute('muted', '');
                } else {
                    this.muted = false;
                    this.volume = 1;
                    this.removeAttribute('muted');
                }
            });
            
            video.addEventListener('ended', () => {
                const slide = video.closest('.swiper-slide');
                if (slide && slide.classList.contains('swiper-slide-active')) {
                    video.currentTime = 0;
                    video.play().catch(err => console.log('Video replay error:', err));
                }
            });
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoSwiper);
    } else {
        initVideoSwiper();
    }
})();
